import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Filter, User, Users, Building2, Calendar, AlertCircle } from "lucide-react";

export const GENERAL_ASSIGNEE = "general";

export function TaskFilters({
  filterStatus,
  onFilterStatusChange,
  filterPriority,
  onFilterPriorityChange,
  filterAssignee,
  onFilterAssigneeChange,
  filterCustomer,
  onFilterCustomerChange,
  users = [],
  customers = [],
  taskCount,
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center justify-between gap-2">
          <span className="flex items-center gap-2">
            <Filter className="w-5 h-5" />
            Filter
          </span>
          {typeof taskCount === "number" && (
            <Badge variant="secondary" data-testid="filter-task-count">
              {taskCount} Aufgabe{taskCount === 1 ? "" : "n"}
            </Badge>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {/* Status Filter */}
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <Calendar className="w-4 h-4" />
            Status
          </Label>
          <Select value={filterStatus} onValueChange={onFilterStatusChange}>
            <SelectTrigger data-testid="filter-status">
              <SelectValue placeholder="Alle Status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle Status</SelectItem>
              <SelectItem value="Offen">Offen</SelectItem>
              <SelectItem value="In Bearbeitung">In Bearbeitung</SelectItem>
              <SelectItem value="Erledigt">Erledigt</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Priority Filter */}
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            Priorität
          </Label>
          <Select value={filterPriority} onValueChange={onFilterPriorityChange}>
            <SelectTrigger data-testid="filter-priority">
              <SelectValue placeholder="Alle Prioritäten" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle Prioritäten</SelectItem>
              <SelectItem value="Hoch">Hoch</SelectItem>
              <SelectItem value="Mittel">Mittel</SelectItem>
              <SelectItem value="Niedrig">Niedrig</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Assignee Filter */}
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <User className="w-4 h-4" />
            Zugewiesen an
          </Label>
          <Select value={filterAssignee} onValueChange={onFilterAssigneeChange}>
            <SelectTrigger data-testid="filter-assignee">
              <SelectValue placeholder="Alle Benutzer" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle Benutzer</SelectItem>
              <SelectItem value={GENERAL_ASSIGNEE} data-testid="filter-assignee-general">
                <span className="flex items-center gap-2">
                  <Users className="w-4 h-4" />
                  Allgemein
                </span>
              </SelectItem>
              {users.map((user) => (
                <SelectItem key={user.id} value={user.id}>
                  {user.full_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Customer Filter */}
        <div className="space-y-2">
          <Label className="flex items-center gap-2">
            <Building2 className="w-4 h-4" />
            Kunde
          </Label>
          <Select value={filterCustomer} onValueChange={onFilterCustomerChange}>
            <SelectTrigger data-testid="filter-customer">
              <SelectValue placeholder="Alle Kunden" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle Kunden</SelectItem>
              {customers.map((customer) => (
                <SelectItem key={customer.id} value={customer.id}>
                  {customer.company_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
